import { Settings } from './../settings/settings';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit, HostListener } from '@angular/core';
import { UserService } from '../user/user.service';
import { CartService } from '../cart/cart.service';
import { Cart } from '../cart/cart';
import { SettingsService } from '../settings/settings.service';
import { RegistryService } from '../registry/registry.service';

import { Registry } from '../registry/registry';
import { ConfigurationService } from '../shared/configuration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Contribution } from '../track/contribution';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnChanges {

  user: User;
  contributions: Contribution[];
  @Input() isOverview: boolean;
  @Input() isContributionsPage: boolean;
  @Input() isContributionsDetailsPage: boolean;
  isLoggedIn: boolean = null;
  cart: Cart;
  alerts: number;
  logoutUrl: string;
  headerType: string;
  isLoaded: boolean = false;
  isLive: boolean = false;
  settings: Settings;
  showMobileMenu: boolean = false;
  @Input() registry: Registry;
  anonymousMode = false;
  responsiveMenuOpen: boolean = false;
  authService: AuthService;
  registryTotal: number = null;
  @Output() loaded: EventEmitter<any>;
contributionLimit: Number;
  currentPosition: number;
  hideMobileMenu: boolean;
  constructor(
    private userService: UserService,
    private cartService: CartService,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private router: Router,
    private registryService: RegistryService,
    private _configuration: ConfigurationService,
    private _authService: AuthService
  ) {
    this.authService = this._authService;
    this.loaded = new EventEmitter<any>();
    this.anonymousMode = false;
    // ;
    if (location.pathname.includes('your-registry') ){
      this.anonymousMode = true;
      this.isLoggedIn = true;
    }
  }
  @HostListener('window:scroll', ['$event'])
  onContentScrolled(e: HTMLElement) {
    
    let scroll = window.scrollY;

    if((document.documentElement.scrollHeight-65) <=  (scroll + window.innerHeight))
    {
      
      this.hideMobileMenu = true;
      this.currentPosition = scroll;
      return;
    }

    if (scroll > this.currentPosition && scroll >2) {
      this.hideMobileMenu = true;
//      console.log("scrollDown");
    } else {
      this.hideMobileMenu = false;
   //   console.log("scrollUp");
    }
    this.currentPosition = scroll;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.processContributions();
  }
  processContributions() {
    
    if (this.contributions && this.contributions.length) {
   
      this.alerts = this.contributions.filter(x => x.seen != true).length;
      this.registryTotal = null;
      this.contributions.forEach(x => {
        this.registryTotal = this.registryTotal + x.giftTotal;
      });
     // this.isLoaded = true;

    } else {
      this.registryTotal = 0;
     // this.isLoaded = true;

    }

  }

  openLink(url){
    let baseUrl = '/registry/';
    if(this.anonymousMode){
      baseUrl = '/your-registry/'
    }
    this.router.navigateByUrl(baseUrl+url)
  }

  viewPlansOrUpgrade(){
;
    if (!this.registry.paid){
      this.router.navigate(['/visibility'])
    }
    else if (this.registry.paid && this.registry.tier != 'full'){
      this.router.navigateByUrl('/visibility')
    }
  }

  ngOnInit() {

    this.authService.user.take(1).subscribe(user => {
      if (user) {

        this._registryFirebaseService.getSettingsForUser(user.userId, user.registryId).subscribe(settings => {
          this.settings = settings;
        });
   
            this._registryFirebaseService.getContributions(null).subscribe(contributions => {
              ;
              this.contributions = contributions;
              this.processContributions();
              if(contributions){
              this.alerts = this.contributions.filter(x => x.seen != true).length;
              }
            });
       



this.loaded.emit()
      }
    });

    this.logoutUrl = this._configuration.baseUrl + "/logout";
    this.userService.headerTypeEmitted$.subscribe(header => {
      this.headerType = header;
      if (this.headerType == "hidenav") {
        this.showMobileMenu = false;
      }


    }
    );

    if (location.pathname == "/404" || location.pathname.toLowerCase() == "/get-started")
      return;

    this._registryFirebaseService.currentRegistry.subscribe(registry => {
      this.registry = registry;
      this.contributionLimit = this._registryFirebaseService.getContributionLimit(this.registry);
      this._authService.user.subscribe(user => {
        this.user = user;
        if (this.user != null) {
          this.isLoggedIn = true;

         // this.isLoaded = true;
        }  else if(this.anonymousMode) {
          this.isLoggedIn = true;

          //this.isLoaded = true;
        } 
        else {
          this.isLoggedIn = false;

          //this.isLoaded = true;
        }
      });

      this.settingsService.changeEmitted$.subscribe(statusChangedTo => this.isLive = statusChangedTo);
      this.cart = this.cartService.getCart();
      this.cartService.changeEmitted$.subscribe(updatedCart => this.cart = updatedCart);
    });
  }


  dismissAlerts() {
    this.settingsService.DismissAlerts().subscribe(x => {
      this.settingsService.GetAlerts().subscribe(alerts => this.alerts = alerts);
    });
  }


  open() {
    let body = document.getElementsByTagName('body')[0];
    body.style.overflow = "hidden";
    this.userService.emitUpdateHeaderType("showMobileMenu");
    this.showMobileMenu = true;
  }

  openPopup(popupType) {
    
    this.registryService.emitGenricPopup(popupType);
  }
  openLinkOrShowPopup(routerUrl) {
    this.router.navigateByUrl(routerUrl);

  }

  close() {
    let body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
    this.showMobileMenu = false;
  }


  openPreview() {
    this.router.navigateByUrl("/" + this.registry.registryName + "?preview=1");
  }

  goToTemplates() {
    this.router.navigateByUrl("/registry/templates")
  }


}





// WEBPACK FOOTER //
// ./src/app/header/header.component.ts